import { getFolderFromRawId } from '../../utils/folderTypeConversionUtil';
import getActionClauseTypeOptions from './getActionClauseTypeOptions';
import getConditionalExceptionClauseTypeOptions from './getConditionalExceptionClauseTypeOptions';
import getExistingClauseTypesInSection from './getExistingClauseTypesInSection';
import mapReadWriteRecipientWellViewStateToPeopleIdentity from './mapReadWriteRecipientWellViewStateToPeopleIdentity';
import { KB_TO_B } from '../../store/schema/ClauseValueType';
import store from '../../store/store';
import getDefaultInboxRuleClauseValue from 'owa-inbox-rules-option/lib/actions/helpers/getDefaultInboxRuleClauseValue';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
/**
 * Maps the rule clauses from the advanced rules option page to an inbox rule
 * @return the InboxRule with the corresponding clauses as properties
 */
export default function createInboxRuleFromStoreEditState(inboxRuleId) {
    var inboxRule = {};
    var editState = store.inboxRulesEditState;
    var clauseMap = editState.clauseMap;
    inboxRule.Name = editState.ruleName;
    var conditionalExistingClauseTypesMap = getExistingClauseTypesInSection('conditional');
    var actionExistingClauseTypesMap = getExistingClauseTypesInSection('action');
    var exceptionExistingClauseTypesMap = getExistingClauseTypesInSection('exception');
    var originalRule = inboxRuleId ? store.inboxRulesListState.inboxRules.get(inboxRuleId) : null;
    // map conditional and exception clauses
    for (var _i = 0, _a = getConditionalExceptionClauseTypeOptions(); _i < _a.length; _i++) {
        var conditionalExceptionClauseType = _a[_i];
        var conditionalClauseId = conditionalExistingClauseTypesMap.get(conditionalExceptionClauseType);
        var exceptionClauseId = exceptionExistingClauseTypesMap.get(conditionalExceptionClauseType);
        var conditionalClauseValue = conditionalClauseId
            ? clauseMap.get(conditionalClauseId).clauseValue
            : null;
        var exceptionClauseValue = exceptionClauseId
            ? clauseMap.get(exceptionClauseId).clauseValue
            : null;
        var defaultValue = getDefaultInboxRuleClauseValue(conditionalExceptionClauseType);
        var originalConditionalValue = void 0;
        var originalExceptionValue = void 0;
        var newConditionalValue = void 0;
        var newExceptionValue = void 0;
        // In this switch statement, we decide whether to set the value of the clause type to be sent to server by the following ways:
        // 1) If there is no new value and there is no old value, do nothing (means user never has this clause type in the rule)
        // 2) Otherwise, get clause value
        // Otherwise do not set because the value has not changed
        switch (conditionalExceptionClauseType) {
            case 'from':
                originalConditionalValue = originalRule ? originalRule.From : defaultValue;
                originalExceptionValue = originalRule ? originalRule.ExceptIfFrom : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.From = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfFrom = value;
                });
                break;
            case 'to':
                originalConditionalValue = originalRule ? originalRule.SentTo : defaultValue;
                originalExceptionValue = originalRule ? originalRule.ExceptIfSentTo : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SentTo = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSentTo = value;
                });
                break;
            case 'onTheToOrCcLine':
                originalConditionalValue = originalRule
                    ? originalRule.MyNameInToOrCcBox
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInToOrCcBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInToOrCcBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInToOrCcBox = value;
                });
                break;
            case 'theOnlyRecipientListed':
                originalConditionalValue = originalRule ? originalRule.SentOnlyToMe : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSentOnlyToMe
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SentOnlyToMe = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSentOnlyToMe = value;
                });
                break;
            case 'onTheToLine':
                originalConditionalValue = originalRule ? originalRule.MyNameInToBox : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInToBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInToBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInToBox = value;
                });
                break;
            case 'onTheCcLine':
                originalConditionalValue = originalRule ? originalRule.MyNameInCcBox : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInCcBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInCcBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInCcBox = value;
                });
                break;
            case 'notOnTheToLine':
                originalConditionalValue = originalRule
                    ? originalRule.MyNameNotInToBox
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameNotInToBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameNotInToBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameNotInToBox = value;
                });
                break;
            case 'subjectIncludes':
                originalConditionalValue = originalRule
                    ? originalRule.SubjectContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSubjectContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SubjectContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSubjectContainsWords = value;
                });
                break;
            case 'subjectOrBodyIncludes':
                originalConditionalValue = originalRule
                    ? originalRule.SubjectOrBodyContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSubjectOrBodyContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SubjectOrBodyContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSubjectOrBodyContainsWords = value;
                });
                break;
            case 'inTheBody':
                originalConditionalValue = originalRule
                    ? originalRule.BodyContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfBodyContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.BodyContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfBodyContainsWords = value;
                });
                break;
            case 'inTheSenderAddress':
                originalConditionalValue = originalRule
                    ? originalRule.FromAddressContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfFromAddressContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.FromAddressContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfFromAddressContainsWords = value;
                });
                break;
            case 'inTheRecipientAddress':
                originalConditionalValue = originalRule
                    ? originalRule.RecipientAddressContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfRecipientAddressContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.RecipientAddressContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfRecipientAddressContainsWords = value;
                });
                break;
            case 'inTheMessageHeader':
                originalConditionalValue = originalRule
                    ? originalRule.HeaderContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfHeaderContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.HeaderContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfHeaderContainsWords = value;
                });
                break;
            case 'withImportance':
                originalConditionalValue = originalRule
                    ? originalRule.WithImportance
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfWithImportance
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithImportance = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithImportance = value;
                });
                break;
            case 'sensitivity':
                originalConditionalValue = originalRule
                    ? originalRule.WithSensitivity
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfWithSensitivity
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithSensitivity = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithSensitivity = value;
                });
                break;
            case 'attachment':
                originalConditionalValue = originalRule ? originalRule.HasAttachment : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfHasAttachment
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.HasAttachment = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfHasAttachment = value;
                });
                break;
            case 'flag':
                originalConditionalValue = originalRule
                    ? originalRule.RequestedAction
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfRequestedAction
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.RequestedAction = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfRequestedAction = value;
                });
                break;
            case 'type':
                originalConditionalValue = originalRule
                    ? originalRule.MessageTypeMatches
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMessageTypeMatches
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MessageTypeMatches = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMessageTypeMatches = value;
                });
                break;
            case 'atLeast':
                originalConditionalValue =
                    originalRule && originalRule.WithinSizeRangeMinimum
                        ? originalRule.WithinSizeRangeMinimum
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfWithinSizeRangeMinimum
                        ? originalRule.ExceptIfWithinSizeRangeMinimum
                        : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapKilobytesToBytes, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapKilobytesToBytes, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithinSizeRangeMinimum = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithinSizeRangeMinimum = value;
                });
                break;
            case 'atMost':
                originalConditionalValue =
                    originalRule && originalRule.WithinSizeRangeMaximum
                        ? originalRule.WithinSizeRangeMaximum
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfWithinSizeRangeMaximum
                        ? originalRule.ExceptIfWithinSizeRangeMaximum
                        : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapKilobytesToBytes, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapKilobytesToBytes, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithinSizeRangeMaximum = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithinSizeRangeMaximum = value;
                });
                break;
            case 'before':
                originalConditionalValue =
                    originalRule && originalRule.ReceivedBeforeDate
                        ? originalRule.ReceivedBeforeDate
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfReceivedBeforeDate
                        ? originalRule.ExceptIfReceivedBeforeDate
                        : defaultValue;
                newConditionalValue = conditionalClauseValue
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseValue
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ReceivedBeforeDate = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfReceivedBeforeDate = value;
                });
                break;
            case 'after':
                originalConditionalValue =
                    originalRule && originalRule.ReceivedAfterDate
                        ? originalRule.ReceivedAfterDate
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfReceivedAfterDate
                        ? originalRule.ExceptIfReceivedAfterDate
                        : defaultValue;
                newConditionalValue = conditionalClauseValue
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseValue
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ReceivedAfterDate = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ExceptIfReceivedAfterDate = value;
                });
                break;
            // Do nothing for any case (server type doesn't have an any-specific field)
            case 'any':
                break;
            default:
                throw new Error('Cannot map an exception inbox rule clause to an inbox rule property for a clause type that does not exist');
        }
    }
    // map action clauses
    for (var _b = 0, _c = getActionClauseTypeOptions(); _b < _c.length; _b++) {
        var actionClauseType = _c[_b];
        var actionClauseId = actionExistingClauseTypesMap.get(actionClauseType);
        var actionClauseValue = actionClauseId ? clauseMap.get(actionClauseId).clauseValue : null;
        var defaultValue = getDefaultInboxRuleClauseValue(actionClauseType);
        var originalValue = void 0;
        var newValue = void 0;
        switch (actionClauseType) {
            case 'moveTo':
                newValue = defaultValue;
                originalValue = originalRule ? originalRule.MoveToFolder : defaultValue;
                var newMoveToFolderId = defaultValue;
                var moveToFolder = actionClauseValue;
                if (moveToFolder) {
                    newMoveToFolderId = moveToFolder.folderId;
                    newValue = {
                        DisplayName: moveToFolder.displayName,
                        RawIdentity: newMoveToFolderId,
                    };
                }
                var originalRuleMoveToFolderId = originalValue
                    ? getFolderFromRawId(originalRule.MoveToFolder.RawIdentity).folderId
                    : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalRuleMoveToFolderId, newMoveToFolderId), function (value) {
                    inboxRule.MoveToFolder = value;
                });
                break;
            case 'copyTo':
                newValue = defaultValue;
                originalValue = originalRule ? originalRule.CopyToFolder : defaultValue;
                var newCopyToFolderId = defaultValue;
                var copyToFolder = actionClauseValue;
                if (copyToFolder) {
                    newCopyToFolderId = copyToFolder.folderId;
                    newValue = {
                        DisplayName: copyToFolder.displayName,
                        RawIdentity: newCopyToFolderId,
                    };
                }
                var originalRuleCopyToFolderId = originalValue
                    ? getFolderFromRawId(originalRule.CopyToFolder.RawIdentity).folderId
                    : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalRuleCopyToFolderId, newCopyToFolderId), function (value) {
                    inboxRule.CopyToFolder = value;
                });
                break;
            case 'delete':
                originalValue = originalRule ? originalRule.DeleteMessage : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.DeleteMessage = value;
                });
                break;
            case 'pin':
                originalValue = originalRule ? originalRule.PinMessage : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.PinMessage = value;
                });
                break;
            case 'read':
                originalValue = originalRule ? originalRule.MarkAsRead : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.MarkAsRead = value;
                });
                break;
            case 'junk':
                // Mark as junk is a special case because there is no server property for it. We give the user the option and do a
                // Move to folder 'Junk Email' under the covers.
                var junkFolderId = folderNameToId('junkemail');
                var newJunkClauseValue = actionClauseId
                    ? {
                        DisplayName: store.junkFolderDisplayName,
                        RawIdentity: junkFolderId,
                    }
                    : defaultValue;
                var originalMoveToFolderId = originalRule && originalRule.MoveToFolder
                    ? getFolderFromRawId(originalRule.MoveToFolder.RawIdentity).folderId
                    : defaultValue;
                var areMoveToAndJunkFoldersEquivalent = originalMoveToFolderId
                    ? newJunkClauseValue && originalMoveToFolderId === junkFolderId
                    : false;
                // Since junk is special, we have to do an additional check if the move to folder on the original rule was a junk folder
                if (newJunkClauseValue && (!originalRule || !areMoveToAndJunkFoldersEquivalent)) {
                    inboxRule.MoveToFolder = newJunkClauseValue;
                }
                else if (!newJunkClauseValue &&
                    (areMoveToAndJunkFoldersEquivalent &&
                        originalRule.MoveToFolder !== defaultValue)) {
                    inboxRule.MoveToFolder = defaultValue;
                }
                break;
            case 'markImportance':
                originalValue = originalRule ? originalRule.MarkImportance : defaultValue;
                newValue = actionClauseId ? actionClauseValue : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.MarkImportance = value;
                });
                break;
            case 'category':
                originalValue = originalRule ? originalRule.ApplyCategory : defaultValue;
                newValue = actionClauseId ? actionClauseValue : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.ApplyCategory = value;
                });
                break;
            case 'forwardTo':
                originalValue = originalRule ? originalRule.ForwardTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.ForwardTo = value;
                });
                break;
            case 'forwardAsAttachmentTo':
                originalValue = originalRule ? originalRule.ForwardAsAttachmentTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.ForwardAsAttachmentTo = value;
                });
                break;
            case 'redirectTo':
                originalValue = originalRule ? originalRule.RedirectTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.RedirectTo = value;
                });
                break;
            default:
                throw new Error('Cannot map an exception inbox rule clause to an inbox rule property for a clause type that does not exist');
        }
    }
    inboxRule.StopProcessingRules = store.inboxRulesEditState.ignoreSubsequentRules;
    if (store.inboxRulesEditState.ruleId) {
        inboxRule.Identity = {
            DisplayName: store.inboxRulesEditState.ruleName,
            RawIdentity: store.inboxRulesEditState.ruleId,
        };
    }
    return inboxRule;
}
// Set inbox rule value to the edit state value if:
// 1) There is an edit state value (user added that clause type) AND
// 2) It is a new rule (no original rule) OR the value of the new rule is different than value of the original rule
// Else if:
// Set inbox rule value to the default inbox rule value if user removes the clause while editing:
// 1) There is no edit state value AND
// 2) There is an original rule (in edit mode) AND the value of the original rule was not the default value
function setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual, valueSetter) {
    if (!areClauseValuesEqual) {
        var valueToSet = void 0;
        if (newValue && newValue != originalValue) {
            valueToSet = newValue;
        }
        else if (!newValue && originalValue != defaultValue) {
            valueToSet = defaultValue;
        }
        valueSetter(valueToSet);
    }
}
function areClauseValuesEqual(originalValue, newValue) {
    return originalValue === newValue;
}
function getClauseValueWithFallback(existingValue, mapFunction, defaultValue) {
    return existingValue ? mapFunction(existingValue) : defaultValue;
}
function mapKilobytesToBytes(clauseValue) {
    return clauseValue * KB_TO_B;
}
//# sourceMappingURL=createInboxRuleFromStoreEditState.js.map